import { Button } from "@focus/focusUI";

import type { DockMode } from "../../types/floatingWindow";

type Props = {
  minimized: boolean;
  dockMode: DockMode;
  onToggleDock: () => void;
  onToggleMinimize: () => void;
  onClose: () => void;
};

export const FloatingWindowControls = ({
  minimized,
  dockMode,
  onToggleDock,
  onToggleMinimize,
  onClose,
}: Props) => {
  return (
    <div className="floating-window-controls flex items-center gap-1">
      {!minimized && (
        <Button
          minimal
          small
          icon={
            dockMode === "floating"
              ? "pin"
              : "widget"
          }
          onClick={onToggleDock}
        />
      )}

      <Button
        minimal
        small
        icon={
          minimized
            ? "maximize"
            : "minus"
        }
        onClick={onToggleMinimize}
      />

      <Button
        minimal
        small
        icon="cross"
        onClick={onClose}
      />
    </div>
  );
};
